import React, { useEffect, useState } from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { Link as RouterLink, Route } from 'react-router-dom';

import { PATHS } from '../enums/PATHS';
import { FOLDER_TYPE } from '../enums/TYPES';
import { useAppSelector } from '../store/hooks';
import { ROLES } from '../enums/ROLES';
import { findSearchValue } from './getSearchValue';
import { getFolderById } from '../api';
import styles from './simpleBreadcrumbs.module.scss';

const SimpleBreadcrumbs = () => {
  const userRole = useAppSelector((state) => state.user.role);
  const folderId = findSearchValue('folderId') as string;
  const [folder, setFolder] = useState<FOLDER_TYPE | null>(null);

  const getCurrentFolderName = async () => {
    try {
      const res = await getFolderById(folderId);
      setFolder(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (PATHS.SHARED_VIDEOFEEDS_LIST.path === location.pathname.split('%20').join(' ') && folderId) {
      // we should get current folder here
    } else if (folderId) {
      getCurrentFolderName();
    } else {
      setFolder(null);
    }
  }, [folderId]);

  return (
    <Route>
      {({ location }) => {
        const pathnames = location.pathname.split('/').filter((x) => x);
        return (
          <div className={styles.wrapper}>
            <Breadcrumbs aria-label="Breadcrumb">
              <RouterLink style={{ textDecoration: 'none', color: 'white' }} to={PATHS.MAIN.path}>
                <h3>Home</h3>
              </RouterLink>
              {pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const to =
                  value === 'File Management'
                    ? userRole === ROLES.VIEWER
                      ? PATHS.SHARED_WITH_ME.path
                      : PATHS.MY_FOLDERS.path
                    : `/${pathnames.slice(0, index + 1).join('/')}`;
                const isAtVideofeeds = to === PATHS.VIDEOFEEDS_LIST.path;
                const isAtSharedWithMe = to === PATHS.SHARED_VIDEOFEEDS_LIST.path;
                const displayValue = isAtVideofeeds || isAtSharedWithMe ? folder?.name : value;
                return last ? (
                  <Typography style={{ textDecoration: 'none', color: 'white' }} key={to}>
                    <h3>{displayValue}</h3>
                  </Typography>
                ) : (
                  <RouterLink style={{ textDecoration: 'none', color: 'white' }} to={to} key={to}>
                    <h3>{displayValue}</h3>
                  </RouterLink>
                );
              })}
            </Breadcrumbs>
          </div>
        );
      }}
    </Route>
  );
};

export default SimpleBreadcrumbs;
